var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "document-previewer",
      "modal-dialog-size": _vm.modalDialogSize,
      "modal-dialog-scrollable": true,
      "loaders-disabled": "",
      "tab-index": null,
      "footer-close-button": false,
    },
    on: { shown: _vm.pullData },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _vm.showSelectScreen
              ? _c("h4", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "document-extraction.selectScreen.documentAssociation"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm.fileName
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col d-flex flex-row justify-content-between align-items-center",
                  },
                  [
                    _c("span", { staticClass: "bold filename text-truncate" }, [
                      _vm._v("\n        " + _vm._s(_vm.fileName) + "\n      "),
                    ]),
                    _vm._v(" "),
                    _vm.previewChanges
                      ? _c(
                          "p",
                          { staticClass: "bold filename text-truncate" },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.currentApplicantTitle) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoaded
                      ? _c("simple-button", {
                          staticStyle: { flex: "none" },
                          attrs: {
                            "button-variant": "outline-primary",
                            type: "primary",
                            text: _vm.tr("document-extraction.viewPDF"),
                            loading: _vm.isLoadingPDF,
                          },
                          on: { click: _vm.handleViewPDF },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                ref: "modalBody",
                staticStyle: { height: "100%", "overflow-y": "auto" },
              },
              [
                _vm.previewChanges
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row justify-content-center align-items-center",
                      },
                      [
                        _c("b-table", {
                          attrs: {
                            striped: "",
                            items: _vm.failover(
                              _vm.changes.items,
                              _vm.changesClone
                            ),
                            fields: _vm.changes.fields,
                            bordered: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(key)",
                                fn: function (ref) {
                                  var key = ref.item.key
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.getKeyName(key)) +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(currentValue)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatValue(
                                            item.currentValue,
                                            item
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(suggestedValue)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatValue(
                                            item.suggestedValue,
                                            item
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4151930436
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isLoaded
                  ? _c(
                      "div",
                      [
                        _c("p", { staticClass: "w-full text-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("document-extraction.loading")) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-progress", {
                          attrs: {
                            animated: "",
                            striped: "",
                            variant: "primary",
                            height: "1rem",
                            value: _vm.loadingProgressCurve,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.hasErrors
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-alert",
                          { attrs: { variant: "danger", show: "" } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("document-extraction.extractionFailed")
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm.showSelectScreen
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "document-extraction.selectScreen.description"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column",
                          staticStyle: { gap: "2em" },
                        },
                        [
                          _c(
                            "SelectScreenItem",
                            {
                              attrs: {
                                index: "1",
                                label: _vm.tr(
                                  "document-extraction.selectScreen.select"
                                ),
                              },
                            },
                            [
                              _c("select2", {
                                ref: "applicantSelect",
                                attrs: {
                                  name: "applicantSelect",
                                  data: _vm.applicants,
                                  value: _vm.currentApplicant,
                                  options: _vm.applicantSelectOptions,
                                  "format-data": _vm.formatApplicantData,
                                },
                                on: { change: _vm.handleApplicantChange },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "SelectScreenItem",
                            {
                              attrs: {
                                index: "2",
                                label: _vm.tr(
                                  "document-extraction.selectScreen.choose"
                                ),
                              },
                            },
                            [
                              _c("select2", {
                                ref: "jobSelect",
                                attrs: {
                                  name: "jobSelect",
                                  disabled: _vm.currentApplicant === -1,
                                  value: _vm.currentJob,
                                  data: _vm.applicantJobs,
                                  options: _vm.jobSelectOptions,
                                  "format-data": _vm.formatJobData,
                                },
                                on: { change: _vm.handleJobChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.previewChanges,
                            expression: "!previewChanges",
                          },
                        ],
                      },
                      [
                        !_vm.isMLS
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex flex-row mb-4",
                                attrs: { id: "top-inputs" },
                              },
                              [
                                _c("select2", {
                                  ref: "applicantSelect",
                                  attrs: {
                                    name: "applicantSelect",
                                    data: _vm.applicants,
                                    value: _vm.currentApplicant,
                                    options: _vm.applicantSelectOptions,
                                    "format-data": _vm.formatApplicantData,
                                  },
                                  on: { change: _vm.handleApplicantChange },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "w-10" }),
                                _vm._v(" "),
                                _c("select2", {
                                  ref: "jobSelect",
                                  attrs: {
                                    name: "jobSelect",
                                    disabled: _vm.currentApplicant === -1,
                                    value: _vm.currentJob,
                                    data: _vm.applicantJobs,
                                    options: _vm.jobSelectOptions,
                                    "format-data": _vm.formatJobData,
                                  },
                                  on: { change: _vm.handleJobChange },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-client-table", {
                          ref: "tableRef",
                          attrs: {
                            columns: _vm.table.columns,
                            options: _vm.table.options,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "h__selected",
                              fn: function () {
                                return [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        checked: _vm.allRowsSelected,
                                        indeterminate: _vm.someRowsSelected,
                                      },
                                      on: { change: _vm.toggleAllSelected },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("document-extraction.apply")
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "key",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "span",
                                    { class: { "ml-4": row.isSubsection } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.getKeyName(row.key)) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "currentValue",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatValue(row.currentValue, row)
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "suggestedValue",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      row.possibleValues.length
                                        ? _c("select-section", {
                                            attrs: {
                                              "placeholder-option": false,
                                              options: row.possibleValues,
                                            },
                                            model: {
                                              value:
                                                _vm.suggestedValues[row.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.suggestedValues,
                                                  row.key,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "suggestedValues[row.key]",
                                            },
                                          })
                                        : row.isHeader
                                        ? _c("span")
                                        : _c(_vm.getInputComponent(row), {
                                            tag: "component",
                                            attrs: {
                                              value:
                                                _vm.suggestedValues[row.key],
                                              "hidden-label": "",
                                            },
                                            on: {
                                              "update:value": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.suggestedValues,
                                                  row.key,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      row.warning
                                        ? _c("icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.top",
                                                value: row.warning,
                                                expression: "row.warning",
                                                modifiers: { top: true },
                                              },
                                            ],
                                            attrs: {
                                              "icon-class": "text-warning ml-2",
                                              name: "exclamation-triangle",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selected",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  !row.isHeader
                                    ? _c("b-form-checkbox", {
                                        model: {
                                          value: _vm.selectedRows[row.key],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedRows,
                                              row.key,
                                              $$v
                                            )
                                          },
                                          expression: "selectedRows[row.key]",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.tableRows,
                            callback: function ($$v) {
                              _vm.tableRows = $$v
                            },
                            expression: "tableRows",
                          },
                        }),
                      ],
                      1
                    ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.previewChanges
              ? _c(
                  "div",
                  [
                    _c("simple-button", {
                      attrs: {
                        type: "primary",
                        text: _vm.tr("settings.visibility.modal.applyChanges"),
                        loading: _vm.isSaving,
                        "loading-succeeded": _vm.savingComplete,
                      },
                      on: { click: _vm.handleApplyValues },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "float-right cancel-modal ml-2",
                        attrs: { variant: "danger" },
                        on: {
                          click: function () {
                            return _vm.handlePreviewChanges(false)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.words.cancel")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column",
                    staticStyle: { gap: "1em" },
                  },
                  [
                    _vm.isLoaded && !_vm.showSelectScreen && !_vm.hasErrors
                      ? _c(
                          "span",
                          {
                            staticClass: "px-2 py-1",
                            staticStyle: {
                              background: "gainsboro",
                              "border-radius": "4px",
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("document-extraction.disclaimer")
                                ) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-end",
                        staticStyle: { gap: "0.5em" },
                      },
                      [
                        !_vm.hasErrors
                          ? _c(
                              "div",
                              [
                                !_vm.showSelectScreen && _vm.tableRef
                                  ? _c("simple-button", {
                                      attrs: {
                                        type: "primary",
                                        disabled: !_vm.getSelectedRows.length,
                                        text: _vm.tr(
                                          "global.actions.previewChanges"
                                        ),
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.handlePreviewChanges(true)
                                        },
                                      },
                                    })
                                  : _c("simple-button", {
                                      attrs: {
                                        type: "primary",
                                        disabled: _vm.currentJob === -1,
                                        text: _vm.tr("global.words.continue"),
                                      },
                                      on: { click: _vm.closeSelectScreen },
                                    }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right cancel-modal",
                            attrs: { variant: "white" },
                            on: { click: _vm.hide },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.close")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }